module.exports = __webpack_public_path__ + "static/media/Klewer.44c53a97.png";